<template>
    <div class="result-message">
        <p>
            <router-link
                v-if="resultMessage.redirect === 'home'"
                class="action"
                :to="redirect"
            >
                {{ $t(`subscription.messages.login_required.home`) }}
            </router-link>
            
            <router-link
                v-else-if="resultMessage.redirect"
                class="action"
                :to="{ name: resultMessage.redirect }"
            >
                {{ $t(`subscription.messages.login_required.login`) }}
            </router-link>

        </p>
    </div>
</template>
<script>
export default {
  name: "ResultMessage",
  props: {
    resultMessage: {},
  },
  computed: {
    redirect() {
      return (this.resultMessage && this.resultMessage.plan_id)
        ? {
            name: "purchase.subscription",
            query: { plan: this.resultMessage.plan_id },
          }
        : {
            name: "home",
          };
    },
  },
};
</script>
<style scoped lang="scss">
@import "./../styles/variables";
@import "./../styles/classes";

.result-message {
  text-align: center;
  border-radius: 3px;
  padding: 5px;
  margin: 5px 0 10px 0;
  background: #fafaff;
  color: var(--pallete_main_color);
  a {
    text-decoration: underline;
    font-weight: bold;
  }
}
</style>
